import { render, staticRenderFns } from "./uploadDocument.vue?vue&type=template&id=137fc1e7"
import script from "./uploadDocument.vue?vue&type=script&lang=js"
export * from "./uploadDocument.vue?vue&type=script&lang=js"
import style0 from "./uploadDocument.vue?vue&type=style&index=0&id=137fc1e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports